import React from 'react'
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom'

function Careerpagebanner() {
const location = useLocation();

  // Get last part of URL, e.g., "about-us"
  const pathName = location.pathname.split('/').filter(Boolean).pop() || 'home';

  // Capitalize and format (e.g., "about-us" => "About Us")
  const formatBreadcrumb = (slug) =>
    slug
      .replace(/-/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());

  const pageTitle = formatBreadcrumb(pathName);

  return (
        <div className="allpages-banner-wrapper">
          <div className="space70"></div>
          <div className="spcae32"></div>
         <div className="inner-header-area" style={{backgroundImage: "url('assets/img/all-images/Banner/Career.png')",
       backgroundPosition: "center",
       backgroundRepeat: "no-repeat",
       backgroundSize: "cover"}}>
           <div className="container">
             <div className="row align-items-center">
               <div className="col-lg-4">
                 <div className="inner-heading">
                  
                   <div className="space20"></div>
                   <a href="/">
                    Home <i className="fa-solid fa-angle-right"></i>{' '}
                    
                   </a>
                   <Link to="/{pageTitle}"></Link>
                    <span>{pageTitle}</span>
                 </div>
               </div>
            
             </div>
           </div>
         </div>
       </div>
  )
}

export default Careerpagebanner;
